<!-- 一般ユーザー　パスワード変更-->
<style src="@/assets/css/common_parts_mypage.css" type="text/css" media="all" scoped></style>
<style src="@/assets/css/common_parts_input.css" type="text/css" media="all" scoped></style>
<style scoped>

</style>
<template>
  <div class="container" id="changePW">
    <div class="contents">
      <h2>マイページ</h2>
      <!-- ▽  -->
      <section id="mainContents">
        <section>
          <h3>【パスワード変更】</h3>
		  	  <p>パスワード変更完了</p>

          <section class="message">
          <p>パスワードの変更が完了しました。</p>
          </section>
        </section>
        <div class="btnLst"><button class="backBtn" v-on:click="onBack">マイページへ戻る</button></div>
      </section>
    </div>
  </div>
</template>
<script>
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

  export default {
    // モジュール名
    name: 'CommonChangePassword2',
    // データ
    data() {
      return {
      }
    },
    methods: {
      // マイページへ戻るボタン
      onBack: function () {
        UtilityConsoleLog.consoleLog('CommonChangePassword2::onBack Start')

        // マイページに遷移
        this.$router.push("/CommonMyPage")

        UtilityConsoleLog.consoleLog('CommonChangePassword2::onBack End')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/ChangePassword/CommonChangePassword2.vue